module.exports = __webpack_public_path__ + "img/7.db014d00.jpg";